module.exports = __webpack_public_path__ + "static/img/4bg_5.9bfbc09.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_5.png
// module id = 707
// module chunks = 1